import React from 'react';
import { Link } from "react-router-dom";
import * as URL from '../../router/url';

const MobileLogo = () => {
    const handleClick = () => {
        window.scrollTo(0,0);
    }

    return (
        <Link to={URL.ROOT} onClick={handleClick}>
            <section className='mobile-logo hide-lg is-family-secondary'>
                <div>Р</div>
                <div>Г</div>
                <div>-</div>
                <div>А</div>
                <div>С</div>
                <div>У</div>
                <div>-</div>
                <div>Н</div>
                <div>А</div>
                <div>Л</div>
                <div>А</div>
                <div>Д</div>
                <div>К</div>
                <div>А</div>
            </section>  
        </Link>  
    )
}

export default MobileLogo;